/** Auto-generated fallback messages from /locale/en/*.json */
export const fallbackMessages: Record<string, string> = {
  'core.appointment.messages.rescheduledOnce': 'Rescheduled once',
  'core.appointment.messages.rescheduledTwice': 'Rescheduled twice',
  'core.appointment.messages.rescheduledCountTimes': 'Rescheduled {count} times',
  'core.customFields.labels.textSingleLine': 'Text - Single Line',
  'core.customFields.labels.textMultipleLines': 'Text - Multiple Lines',
  'core.customFields.labels.date': 'Date',
  'core.customFields.labels.trueFalse': 'True/False',
  'core.customFields.labels.singleDocument': 'Single Document',
  'core.customFields.labels.multiDocument': 'Multi Document',
  'core.customFields.labels.number': 'Number',
  'core.customFields.labels.eMail': 'E-mail',
  'core.customFields.labels.phone': 'Phone',
  'core.customFields.labels.dropDownSingleSelectList': 'Drop-down Single Select List',
  'core.customFields.labels.dropDownMultiSelectList': 'Drop-down Multi Select List',
  'core.customFields.labels.comboBox': 'Combo Box',
  'core.customFields.labels.timestamp': 'Timestamp',
  'core.customFields.labels.featureLink': 'Feature Link',
  'core.customFields.descriptions.openTextFieldSingleLine': 'Open text field, single line',
  'core.customFields.descriptions.openTextFieldMultipleLines': 'Open text field, multiple lines',
  'core.customFields.descriptions.formatMmDdYyyy': 'Format MM/DD/YYYY',
  'core.customFields.descriptions.toggleButton': 'Toggle Button',
  'core.customFields.descriptions.singleFileUploadField': 'Single file upload field',
  'core.customFields.descriptions.multipleFileUploadField': 'Multiple file upload field',
  'core.customFields.descriptions.numericInputField': ' Numeric input field',
  'core.customFields.descriptions.emailAddressInputField': 'Email address input field',
  'core.customFields.descriptions.format1XxxXxxXxxx': 'Format +1(XXX) XXX-XXXX',
  'core.customFields.descriptions.selectOneOptionFromAList': 'Select one option from a list',
  'core.customFields.descriptions.selectMultipleOptionsFromAList':
    'Select multiple options from a list',
  'core.customFields.descriptions.singleOptionDropDownListOpenTextField':
    'Single option drop-down list + open text field',
  'core.customFields.descriptions.dateAndTimeFields': 'Date and time fields',
  'core.customFields.descriptions.linkToTheFormFeatures': 'Link to the form features',
  'core.customForms.customFormsFeaturesData.titles.checkOut': 'Check-Out',
  'core.customForms.customFormsFeaturesData.titles.checkInDeprecated': 'Check-in (Deprecated)',
  'core.customForms.customFormsFeaturesData.titles.checkIn': 'Check-in',
  'core.customForms.customFormsFeaturesData.titles.appointmentCompleted': 'Appointment Completed',
  'core.customForms.customFormsFeaturesData.titles.receivedLoadInspection':
    'Received Load Inspection',
  'core.customForms.customFormsFeaturesData.titles.shippedLoadVerification':
    'Shipped Load Verification',
  'core.customForms.customFormsFeaturesData.titles.appointmentsPerLoadType':
    'Appointments per Load Type',
  'core.customForms.customFormsFeaturesData.titles.assetDetails': 'Asset Details',
  'core.customForms.customFormsFeaturesData.titles.yardManagementSystem': 'Yard Management System',
  'core.customForms.customFormsFeaturesData.titles.smartGateIntegration': 'SmartGate integration',
  'core.customForms.customFormsFeaturesData.titles.gateManagement': 'Gate Management',
  'core.customForms.customFormsFeaturesData.subtitles.phoneNumberAndCarrierCompanyWillBeCollectedByDefault':
    '<strong>Phone number</strong> and <strong>carrier company</strong> will be collected by default',
  'core.customForms.customFormsFeaturesData.descriptions.captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals':
    'Capture check-in details from drivers for both planned and unplanned arrivals.',
  'core.customForms.customFormsFeaturesData.descriptions.captureCheckOutDataAfterAnAppointmentIsCompleted':
    'Capture check-out data after an appointment is completed.',
  'core.customForms.customFormsFeaturesData.descriptions.reviewAndManageAppointmentDataAfterCompletion':
    'Review and manage appointment data after completion.',
  'core.customForms.customFormsFeaturesData.descriptions.collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution':
    'Collect driver info as they self check-in for their planned appointment. This feature is an optional add-on to our Gate Management solution.',
  'core.customForms.customFormsFeaturesData.descriptions.documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad':
    'Document damage, discrepancies or other issues related to the received load.',
  'core.customForms.customFormsFeaturesData.descriptions.documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad':
    'Document load integrity and other security measures related to the shipped load.',
  'core.customForms.customFormsFeaturesData.descriptions.captureLoadTypeSpecificDetailsDuringAppointmentScheduling':
    'Capture load type specific details during appointment scheduling.',
  'core.customForms.customFormsFeaturesData.descriptions.storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard':
    'Store and track details of trailers and containers as they arrive at your yard.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp':
    'Enable the YMS module for this warehouse, also enable the asset visit fields for the gate management app.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheSmartGateModuleForThisWarehouse':
    'Enable the SmartGate module for this warehouse.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheShipperGuideModuleForThisWarehouse':
    'Enable the ShipperGuide module for this warehouse.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheIdValidationForThisWarehouse':
    'Enable the ID Validation module for this warehouse.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn':
    'Enable the Gate Management module for this warehouse, which includes the check-in',
  'core.customForms.customFormsFeaturesData.descriptions.enterTheWeightOfTheCargo':
    'Enter the weight of the cargo',
  'core.customForms.customFormsFeaturesData.descriptions.uploadEvidencesOfTheCheckOutEvent':
    'Upload evidences of the check-out event',
  'core.customForms.customFormsFeaturesData.descriptions.appointmentCheckOutForm':
    'Appointment check-out form',
  'core.customForms.customFormsFeaturesData.descriptions.claimTrackingForm': 'Claim tracking form',
  'core.customForms.customFormsFeaturesData.descriptions.pleaseFillOutTheRequiredInformationIfYouWantToConfirmTheCheckOutForThisAppointment':
    'Please fill out the required information if you want to confirm the check-out for this appointment',
  'core.customForms.customFormsFeaturesData.descriptions.selectOneOrMoreOptionsThatBestIdentifyTheTypeOfDamage':
    'Select one or more options that best identify the type of damage',
  'core.customForms.customFormsFeaturesData.descriptions.provideMoreInformationAboutTheIdentifiedDamageSuchAsExtentAndAffectedAreas':
    'Provide more information about the identified damage, such as extent and affected areas',
  'core.customForms.customFormsFeaturesData.descriptions.uploadPhotosOrAnyEvidenceOfTheIdentifiedDamage':
    'Upload photos or any evidence of the identified damage',
  'core.customForms.customFormsFeaturesData.descriptions.selectOneOrMoreTypesOfDiscrepancyObservedInTheReceivedLoad':
    'Select one or more types of discrepancy observed in the received load',
  'core.customForms.customFormsFeaturesData.descriptions.provideMoreInformationAboutTheIdentifiedDiscrepancySuchAsTheQuantityDifferenceAndMissingItems':
    'Provide more information about the identified discrepancy, such as the quantity difference and missing items',
  'core.customForms.customFormsFeaturesData.descriptions.uploadPhotosDocumentsOrAnyEvidenceOfTheIdentifiedDiscrepancy':
    'Upload photos, documents or any evidence of the identified discrepancy',
  'core.customForms.customFormsFeaturesData.descriptions.inboundClaimEvidenceForm':
    'Inbound Claim Evidence Form',
  'core.customForms.customFormsFeaturesData.descriptions.pleaseFillOutThisFormToDocumentDamageOrOtherIssuesRelatedToTheReceivedLoad':
    'Please fill out this form to document damage or other issues related to the received load',
  'core.customForms.customFormsFeaturesData.descriptions.informIfTheLoadHasPassedTheSecurityCheck':
    'Inform if the load has passed the security check',
  'core.customForms.customFormsFeaturesData.descriptions.provideMoreInformationOnHowTheLoadWasSecuredTheOverallIntegrityAndOtherHandlingPrecautionsTaken':
    'Provide more information on how the load was secured, the overall integrity and other handling precautions taken',
  'core.customForms.customFormsFeaturesData.descriptions.uploadPhotosOfOverallConditionArrangementAndSecurityOfTheLoadAndTrailer':
    'Upload photos of overall condition, arrangement, and security of the load and trailer',
  'core.customForms.customFormsFeaturesData.descriptions.uploadPhotosOfTheSealsToDocumentTheirIntegrityAndProperPlacement':
    'Upload photos of the seals to document their integrity and proper placement',
  'core.customForms.customFormsFeaturesData.descriptions.outboundClaimEvidenceForm':
    'Outbound Claim Evidence Form',
  'core.customForms.customFormsFeaturesData.descriptions.pleaseFillOutThisFormToDocumentSecurityDetailsOrOtherEvidenceRelatedToTheShippedLoad':
    'Please fill out this form to document security details or other evidence related to the shipped load',
  'core.customForms.customFormsFeaturesData.helpLinks.learnHowItWorksOrContactUsToRequestATrial':
    '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works</a> or contact us to <a href="https://lp.opendock.com/gate-management" target="_blank">request a trial.</a>.',
  'core.customForms.customFormsFeaturesData.helpLinks.learnHowItWorks':
    '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works.</a>',
  'core.customForms.customFormsFeaturesData.enableDisclaimers.theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn':
    'The drivers will see this form when they are checking themselves in.',
  'core.customForms.customFormsFeaturesData.enableDisclaimers.allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling':
    'All Fields on this form will be <strong>available and visible</strong> during appointment scheduling.',
  'core.customForms.customFormsFeaturesData.disableDisclaimers.theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn':
    'The drivers will not see this form when they are checking themselves in.',
  'core.customForms.customFormsFeaturesData.disableDisclaimers.allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime':
    'All Fields on this form will be <strong>unavailable</strong> during appointment scheduling.<br />You can re-enable this form at any time.',
  'core.customForms.customFormsFeaturesData.labels.checkOutTime': 'Check-out Time',
  'core.customForms.customFormsFeaturesData.labels.checkOutWeight': 'Check-out Weight',
  'core.customForms.customFormsFeaturesData.labels.checkOutDocument': 'Check-out Document',
  'core.customForms.customFormsFeaturesData.labels.checkOutDamage': 'Check-out Damage?',
  'core.customForms.customFormsFeaturesData.labels.updateClaimsSupport': 'Update Claims Support',
  'core.customForms.customFormsFeaturesData.labels.selectAClaimsSupportToUpdate':
    'Select a Claims Support to update',
  'core.customForms.customFormsFeaturesData.labels.claimsSupportFormsCanAlsoBeUpdatedDirectlyFromTheClaimsSupportTab':
    'Claims Support forms can also be updated directly from the Claims Support tab',
  'core.customForms.customFormsFeaturesData.labels.checkOutForm': 'Check-out Form',
  'core.customForms.customFormsFeaturesData.labels.claimsForm': 'Claims Form',
  'core.customForms.customFormsFeaturesData.labels.damageType': 'Damage Type',
  'core.customForms.customFormsFeaturesData.labels.damageDescription': 'Damage Description',
  'core.customForms.customFormsFeaturesData.labels.damagePhotos': 'Damage Photos',
  'core.customForms.customFormsFeaturesData.labels.discrepancyType': 'Discrepancy Type',
  'core.customForms.customFormsFeaturesData.labels.discrepancyDescription':
    'Discrepancy Description',
  'core.customForms.customFormsFeaturesData.labels.discrepancyPhotos': 'Discrepancy Photos',
  'core.customForms.customFormsFeaturesData.labels.inboundClaimEvidenceForm':
    'Inbound Claim Evidence Form',
  'core.customForms.customFormsFeaturesData.labels.receivedLoadInspection':
    'Received Load Inspection',
  'core.customForms.customFormsFeaturesData.labels.loadSecurityChecked': 'Load Security Checked',
  'core.customForms.customFormsFeaturesData.labels.loadSecurityDescription':
    'Load Security Description',
  'core.customForms.customFormsFeaturesData.labels.loadIntegrityPhotos': 'Load Integrity Photos',
  'core.customForms.customFormsFeaturesData.labels.sealIntegrityPhotos': 'Seal Integrity Photos',
  'core.customForms.customFormsFeaturesData.labels.outboundClaimEvidenceForm':
    'Outbound Claim Evidence Form',
  'core.customForms.customFormsFeaturesData.labels.shippedLoadVerification':
    'Shipped Load Verification',
  'core.customForms.customFormsFeaturesData.placeholders.enterDetailsAndObservationsAboutTheDamage':
    'Enter details and observations about the damage',
  'core.customForms.customFormsFeaturesData.placeholders.enterDetailsAndObservationsAboutTheDiscrepancy':
    'Enter details and observations about the discrepancy',
  'core.customForms.customFormsFeaturesData.placeholders.enterDetailsOnLoadSecuringMeasuresAndOtherObservations':
    'Enter details on load securing measures and other observations',
  'core.customForms.customFormsFeaturesData.dropdownValues.noDamage': 'No Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.visibleDamage': 'Visible Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.concealedDamage': 'Concealed Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.brokenPalletsCrates':
    'Broken Pallets/Crates',
  'core.customForms.customFormsFeaturesData.dropdownValues.damageToTrailer': 'Damage to Trailer',
  'core.customForms.customFormsFeaturesData.dropdownValues.packagingDamage': 'Packaging Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.unsecuredOrShiftedLoad':
    'Unsecured or Shifted Load',
  'core.customForms.customFormsFeaturesData.dropdownValues.brokenOrLooseSeal':
    'Broken or Loose Seal',
  'core.customForms.customFormsFeaturesData.dropdownValues.temperatureRelatedDamage':
    'Temperature-Related Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.spillsAndLeaks': 'Spills and Leaks',
  'core.customForms.customFormsFeaturesData.dropdownValues.contaminationParasitesMoldSmell':
    'Contamination(parasites, mold, smell)',
  'core.customForms.customFormsFeaturesData.dropdownValues.noDiscrepancy': 'No Discrepancy',
  'core.customForms.customFormsFeaturesData.dropdownValues.loss': 'Loss',
  'core.customForms.customFormsFeaturesData.dropdownValues.shortage': 'Shortage',
  'core.customForms.customFormsFeaturesData.dropdownValues.overage': 'Overage',
  'core.customForms.customFormsFeaturesData.dropdownValues.incorrectDelivery': 'Incorrect Delivery',
  'core.customForms.customFormsFeaturesData.dropdownValues.wrongItemShipped': 'Wrong Item Shipped',
  'core.customForms.customFormsFeaturesData.dropdownValues.missingOrIncorrectDocumentation':
    'Missing or Incorrect Documentation',
  'core.customForms.customFormsFeaturesData.dropdownValues.missingOrIncorrectLabel':
    'Missing or Incorrect Label',
  'core.customForms.customFormsFeaturesData.dropdownValues.incorrectSku': 'Incorrect SKU',
  'core.customForms.customFormsFeaturesData.dropdownValues.packagingDiscrepancyWrongTypeOrSize':
    'Packaging Discrepancy (wrong type or size)',
  'core.customForms.customFormsFeaturesData.dropdownValues.incorrectPalletization':
    'Incorrect Palletization',
  'core.global.entities.warehouses': 'Warehouse | Warehouses',
  'core.global.entities.loadTypes': 'Load Type | Load Types',
  'core.global.entities.docks': 'Dock | Docks',
  'core.global.entities.appointments': 'Appointment | Appointments',
  'core.global.entities.users': 'User | Users',
  'core.global.entities.organizations': 'Organization | Organizations',
  'core.global.entities.orgs': 'Org | Orgs',
  'core.global.entities.companies': 'Company | Companies',
  'core.notifications.titles.appointmentDetailsHaveChanged': 'Appointment details have changed',
  'core.notifications.titles.appointmentScheduled': 'Appointment scheduled',
  'core.notifications.titles.appointmentConfirmed': 'Appointment confirmed',
  'core.notifications.titles.appointmentRequested': 'Appointment requested',
  'core.notifications.titles.missedAppointment': 'Missed appointment',
  'core.notifications.titles.recurringAppointmentSeriesCreated':
    'Recurring appointment series created',
  'core.notifications.titles.truckArrivedAtFacility': 'Truck arrived at facility',
  'core.notifications.titles.appointmentIsInProgressAtFacility':
    'Appointment is in progress at facility',
  'core.notifications.titles.appointmentRescheduled': 'Appointment rescheduled',
  'core.notifications.titles.appointmentCompleted': 'Appointment completed',
  'core.notifications.titles.appointmentCancelled': 'Appointment cancelled',
  'core.notifications.titles.appointmentTagged': 'Appointment tagged',
  'core.notifications.subjects.appointmentDetailsHaveChanged': 'Appointment details have changed',
  'core.notifications.subjects.appointmentScheduled':
    'Appointment scheduled at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentConfirmed':
    'Appointment confirmed at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentRequested':
    'Appointment requested at {orgName} - {warehouseName}',
  'core.notifications.subjects.missedAppointment':
    'Missed appointment at {orgName} - {warehouseName}',
  'core.notifications.subjects.recurringAppointmentSeriesCreated':
    'Recurring appointment series has been created',
  'core.notifications.subjects.truckArrivedAtFacility':
    'Truck arrived at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentIsInProgressAtFacility':
    'Appointment is in progress at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentRescheduled':
    'Appointment rescheduled at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentCompleted':
    'Appointment completed at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentCancelled':
    'Appointment cancelled with {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentTagged':
    'Appointment tagged as {tagName} - {warehouseName}',
  'core.notifications.subTitles.appointmentDetailsHaveChanged':
    'Please check location, date, time and all details below.',
  'core.notifications.subTitles.appointmentScheduled':
    'Please check location, date, time and all details below.',
  'core.notifications.subTitles.appointmentConfirmed':
    'Please check location, date, time and all details below.',
  'core.notifications.subTitles.appointmentRequested': 'Please wait for warehouse confirmation.',
  'core.notifications.subTitles.missedAppointment': 'Carrier did not show for the appointment.',
  'core.notifications.subTitles.recurringAppointmentSeriesCreated':
    'Please check the details of the recurring appointment below.',
  'core.notifications.subTitles.truckArrivedAtFacility':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentIsInProgressAtFacility':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentRescheduled':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentCompleted':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentCancelled':
    'Please check all details and reason for cancellation.',
  'core.notifications.subTitles.appointmentTagged':
    'Please check the tag name and information below.',
  'core.notifications.anchorLabels.appointmentDetailsHaveChanged': 'View Appointment',
  'core.notifications.anchorLabels.appointmentScheduled': 'View Appointment',
  'core.notifications.anchorLabels.appointmentConfirmed': 'View Appointment',
  'core.notifications.anchorLabels.appointmentRequested': 'View Appointment',
  'core.notifications.anchorLabels.missedAppointment': 'View Appointment',
  'core.notifications.anchorLabels.recurringAppointmentSeriesCreated': 'View Original Appointment',
  'core.notifications.anchorLabels.truckArrivedAtFacility': 'View Appointment',
  'core.notifications.anchorLabels.appointmentIsInProgressAtFacility': 'View Appointment',
  'core.notifications.anchorLabels.appointmentRescheduled': 'View Appointment',
  'core.notifications.anchorLabels.appointmentCompleted': 'View Appointment',
  'core.notifications.anchorLabels.appointmentCancelled': 'View Appointment',
  'core.notifications.anchorLabels.appointmentTagged': 'View Appointment',
  'core.notifications.meta.contentBlockTitle': 'Content Block',
  'core.notifications.meta.contentBlockDescription':
    'This content is placed below the confirmation/reference number and above the appointment details.',
  'core.notifications.descriptions.appointmentTagged':
    'Use Appointment Tags setting to enable tags individually',
  'core.settings.groups.referenceNumber': 'Reference Number',
  'core.settings.groups.appointmentStartTimes': 'Appointment Start Times',
  'core.settings.groups.appointmentNotifications': 'Appointment Notifications',
  'core.settings.groups.appointmentStatuses': 'Appointment Statuses',
  'core.settings.groups.customAppointmentsGrid': 'Custom Appointments Grid',
  'core.settings.groups.limit': 'Limit',
  'core.settings.groups.schedulingPortal': 'Scheduling Portal',
  'core.settings.groups.dockSelection': 'Dock Selection',
  'core.settings.groups.timeDisplay': 'Time Display',
  'core.settings.groups.gateManagement': 'Gate Management',
  'core.settings.groups.smartGate': 'SmartGate',
  'core.settings.groups.shipperGuideIntegration': 'ShipperGuide Integration',
  'core.settings.groups.idValidation': 'ID Validation',
  'core.settings.groups.appointmentValidation': 'Appointment Validation',
  'core.settings.groups.other': 'Other',
  'core.settings.groupDescriptions.referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment':
    "Reference Number is the reference you can request from carriers when they're scheduling an appointment.",
  'core.settings.groupDescriptions.determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart':
    'Determine the time intervals at which appointments will be allowed to start.',
  'core.settings.groupDescriptions.manageAllTypesOfAppointmentNotificationsForThisEntity':
    'Manage all types of appointment notifications for this {entity}.',
  'core.settings.groupDescriptions.manageTheSchedulingPortalSettingsForThisEntity':
    'Manage the Scheduling Portal settings for this {entity}',
  'core.settings.labels.minimumAmountOfReferenceNumbers': 'Minimum Amount of Reference Numbers',
  'core.settings.labels.maximumAmountOfReferenceNumbers': 'Maximum Amount of Reference Numbers',
  'core.settings.labels.includeReferenceNumberFieldOnAllAppointmentForms':
    'Include Reference Number field on all appointment forms?',
  'core.settings.labels.referenceNumberFieldName': 'Reference Number field name',
  'core.settings.labels.referenceNumberHelperText': 'Reference Number helper text',
  'core.settings.labels.makeReferenceNumberARequiredField':
    'Make Reference Number a required field?',
  'core.settings.labels.allowAppointmentsForThisEntityToStartAt':
    'Allow appointments for this {entity} to start at:',
  'core.settings.labels.enableAppointmentNotificationsForThisEntity':
    'Enable appointment notifications for this {entity}?',
  'core.settings.labels.selectEachDesiredStartTimeIndividually':
    'Select each desired start time individually',
  'core.settings.labels.hideTheLoadTypeDuration': 'Hide the load type duration?',
  'core.settings.labels.uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications':
    'Upload your {entity} logo to display it in the Scheduling Portal and in all email notifications',
  'core.settings.labels.uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal':
    'Upload your warehouse yard map to display it in the Scheduling Portal',
  'core.settings.labels.statusForNewlyCreatedAppointments': 'Status for newly created appointments',
  'core.settings.labels.muteAppointmentNotifications': 'Mute Appointment Notifications',
  'core.settings.labels.allowDockSelectionInSchedulingPortal':
    'Allow Dock selection in Scheduling Portal?',
  'core.settings.labels.theStatusThatFollowsArrivedIs': "The status that follows 'Arrived' is",
  'core.settings.labels.displayTimeIn': 'Display time in:',
  'core.settings.labels.customizeAppointmentDetails': 'Customize appointment details',
  'core.settings.labels.gridTileConfig': 'Grid tile config',
  'core.settings.labels.enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation':
    'Enforce geofencing to require drivers to provide their real time location',
  'core.settings.labels.wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional':
    'Would you like to show additional information to the drivers after they check in? (optional)',
  'core.settings.labels.preventReschedulingAppointmentsInTheSchedulingPortal':
    'Prevent rescheduling appointments in the Scheduling Portal?',
  'core.settings.labels.observationMatchAttribute': 'Observation Match Attribute',
  'core.settings.labels.observationMatchTimeWindow': 'Observation Match Time Window',
  'core.settings.labels.checkInEarlyThreshold': 'Check-in Early Threshold',
  'core.settings.labels.checkInLateThreshold': 'Check-in Late Threshold',
  'core.settings.labels.technicalContactEmailAddress': 'Technical Contact Email Address',
  'core.settings.labels.technicalContactEmailThrottleMinutes':
    'Technical Contact Email Throttle Minutes',
  'core.settings.labels.requireUniqueReferenceNumbers': 'Require Unique Reference Numbers',
  'core.settings.labels.appointmentStartTimeInterval': 'Appointment Start Time Interval',
  'core.settings.labels.enableCustomAppointmentStartTimes': 'Enable Custom Appointment Start Times',
  'core.settings.labels.referenceNumberInputMode': 'Reference Number Input Mode',
  'core.settings.labels.uploadWarehouseYardMap':
    'Upload your warehouse yard map to display it in the Scheduling Portal',
  'core.settings.descriptions.requireAtLeastThisAmountOfReferenceNumbersForAnAppointment':
    'Require at least this amount of reference numbers for an appointment',
  'core.settings.descriptions.requireAtMostThisAmountOfReferenceNumbersForAnAppointment':
    'Require at most this amount of reference numbers for an appointment',
  'core.settings.descriptions.theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId':
    'The display name for the Reference Number field. Eg: "PO Number", "Shipment ID"',
  'core.settings.descriptions.additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx':
    'Additional information to help fill in the Reference Number field.  Eg: "Reference Number should start with OD-XX"',
  'core.settings.descriptions.requireTheReferenceNumberForAllAppointmentsBeingScheduled':
    'Require the Reference Number for all appointments being scheduled',
  'core.settings.descriptions.thisOnlyAffectsNewlyCreatedAppointments':
    'This only affects newly created appointments',
  'core.settings.descriptions.theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal':
    'The duration is displayed on the Load Types select list booking an appointment in the Scheduling Portal',
  'core.settings.descriptions.allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal':
    'Allow Dock selection when booking an appointment in the Scheduling Portal',
  'core.settings.descriptions.thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted':
    "This setting will allow the choice of an alternate 'In Progress' status between 'Arrived' and 'Completed'",
  'core.settings.descriptions.determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports':
    'Determine how time will be displayed across the platform for all users of this Org, including the appointments grid and reports.',
  'core.settings.descriptions.enableToSwitchToTheNewCustomizableAppointmentDetailsSystem':
    'Enable to switch to the new customizable appointment details system',
  'core.settings.descriptions.userConfigurationOfHowGridTilesWillBeDisplayed':
    'User configuration of how grid tiles will be displayed.',
  'core.settings.descriptions.thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse':
    'This setting asks for the drivers location and restricts them from checking-in when they are more than one mile away from your warehouse.',
  'core.settings.descriptions.preventCarriersFromReschedulingAppointmentsOptional':
    'Prevent carriers from rescheduling appointments. (optional)',
  'core.settings.descriptions.attributeToBeUsedForMatchingObservations':
    'Attribute to be used for matching observations',
  'core.settings.descriptions.theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime':
    'The number of minutes to account for an observation before and after the check-in time',
  'core.settings.descriptions.theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn':
    'The number of minutes before the appointment start time that a carrier can check in',
  'core.settings.descriptions.theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn':
    'The number of minutes after the appointment start time that a carrier can check in',
  'core.settings.descriptions.emailAddressWhereTechnicalIssuesAndInformationWillBeSent':
    'Email address where technical issues and information will be sent',
  'core.settings.descriptions.theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs':
    'The time between notifications sent to the technical contact when a validation server error occurs.',
  'core.settings.descriptions.aListOfMutedAppointmentNotifications':
    'A list of muted appointment notifications.',
  'core.settings.descriptions.appointmentNotificationsWillBeSent':
    'Appointment notifications will be sent',
  'core.settings.descriptions.appointmentNotificationsWillNOTBeSentBrStrongCautionStrongALLAppointmentNotificationsWillBeMutedForYourEntityForALLUsersIncludingCarriers':
    'Appointment notifications will <strong>NOT</strong> be sent.<br/><strong>Caution:</strong> ALL appointment notifications will be muted for your {entity} for ALL users including carriers.',
  'core.settings.descriptions.requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled':
    'Require unique Reference Numbers for all appointments being scheduled',
  'core.settings.descriptions.thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart':
    'This is the interval minutes between when appointments can start',
  'core.settings.descriptions.enableTheCustomAppointmentStartTimesSetting':
    'Enable the custom appointment start times setting',
  'core.settings.descriptions.theInputModeForTheReferenceNumberField':
    'The input mode for the reference number field',
  'core.settings.descriptions.autoDepartAssetsOnReceivingOutgateEvent':
    'Auto depart assets on receiving outgate event',
  'core.settings.placeholders.referenceNumberAssociatedWithAppointment':
    'Reference Number associated with appointment',
  'core.settings.placeholders.insertMessageHere': 'Insert message here',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.topOfTheHour00':
    'Top of the hour (:00)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.topAndBottomOfTheHour00And30':
    'Top and bottom of the hour (:00 and :30)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.everyTwentyMinutes0020And40':
    'Every Twenty Minutes (:00, :20, and :40)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.everyQuarterOfTheHour001530And45':
    'Every quarter of the hour (:00, :15, :30, and :45)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.customStartTimes':
    'Custom start times',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.15Minutes': '15 Minutes',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.30Minutes': '30 Minutes',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.60Minutes': '60 Minutes',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.90Minutes': '90 Minutes',
  'core.settings.dropdownOptions.observationMatchAttribute.licensePlate': 'License Plate',
  'core.settings.dropdownOptions.observationMatchAttribute.dotNumber': 'DOT Number',
  'core.settings.dropdownOptions.observationMatchAttribute.any': 'Any',
  'core.settings.dropdownOptions.referenceNumberInputMode.alphanumeric': 'Alphanumeric',
  'core.settings.dropdownOptions.referenceNumberInputMode.numeric': 'Numeric',
  'core.settings.dropdownOptions.statusForNewlyCreatedAppointments.scheduled': 'Scheduled',
  'core.settings.dropdownOptions.statusForNewlyCreatedAppointments.requested': 'Requested',
  'core.settings.dropdownOptions.theStatusThatFollowsArrivedIs.inProgress': 'In Progress',
  'core.settings.dropdownOptions.theStatusThatFollowsArrivedIs.completed': 'Completed',
  'core.settings.dropdownOptions.includeReferenceNumberFieldOnAllAppointmentForms.noDontIncludeTheReferenceNumberField':
    "No, don't include the Reference Number field",
  'core.settings.dropdownOptions.includeReferenceNumberFieldOnAllAppointmentForms.yesIncludeTheReferenceNumberField':
    'Yes, include the Reference Number field',
  'core.settings.dropdownOptions.hideTheLoadTypeDuration.noDontHideTheLoadTypeDuration':
    "No, don't hide the Load Type duration",
  'core.settings.dropdownOptions.hideTheLoadTypeDuration.yesHideTheLoadTypeDuration':
    'Yes, hide the Load Type duration',
  'core.settings.dropdownOptions.enableAppointmentNotificationsForThisEntity.noDisableAppointmentNotifications':
    'No, disable appointment notifications',
  'core.settings.dropdownOptions.enableAppointmentNotificationsForThisEntity.yesEnableAppointmentNotifications':
    'Yes, enable appointment notifications',
  'core.settings.dropdownOptions.allowDockSelectionInSchedulingPortal.noDontAllowDockSelection':
    "No, don't allow Dock selection",
  'core.settings.dropdownOptions.allowDockSelectionInSchedulingPortal.yesAllowTheDockSelection':
    'Yes, allow the Dock selection',
  'core.settings.dropdownOptions.displayTimeIn.regularTime12Hour': 'Regular time (12-hour)',
  'core.settings.dropdownOptions.displayTimeIn.militaryTime24Hour': 'Military time (24-hour)',
  'core.settings.dropdownOptions.preventReschedulingAppointmentsInTheSchedulingPortal.allowReschedulingInTheSchedulingPortal':
    'Allow rescheduling in the Scheduling Portal ',
  'core.settings.dropdownOptions.preventReschedulingAppointmentsInTheSchedulingPortal.preventReschedulingInTheSchedulingPortal':
    'Prevent rescheduling in the Scheduling Portal',
  'core.settings.dropdownOptions.makeReferenceNumberARequiredField.noDontMakeReferenceNumberARequiredField':
    "No, don't make Reference Number a required field",
  'core.settings.dropdownOptions.makeReferenceNumberARequiredField.yesMakeReferenceNumberARequiredField':
    'Yes, make Reference Number a required field',
  'core.settings.dropdownOptions.requireUniqueReferenceNumbers.noDontRequireUniqueReferenceNumbers':
    "No, don't require unique Reference Numbers",
  'core.settings.dropdownOptions.requireUniqueReferenceNumbers.yesRequireUniqueReferenceNumbers':
    'Yes, require unique Reference Numbers',
  'core.settings.labels.enableCheckInIdValidationPersona':
    'Enable check-in ID validation (Persona)',
  'core.settings.labels.requireCheckInIdValidationToCompleteCheckIn':
    'Require check-in ID validation to complete check-in',
  'core.settings.labels.checkInIdValidationTemplate': 'Check-in ID validation template',
  'core.settings.descriptions.showThePersonaComponentInTheCheckInFlowForIdentityVerification':
    'Show the Persona component in the check-in flow for identity verification',
  'core.settings.descriptions.requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn':
    'Require successful Persona validation before the driver can complete check-in',
  'core.settings.descriptions.personaTemplateUsedForCheckInIdentityVerification':
    'Persona template used for check-in identity verification',
  'core.settings.dropdownOptions.enableCheckInIdValidationPersona.no': 'No',
  'core.settings.dropdownOptions.enableCheckInIdValidationPersona.yes': 'Yes',
  'core.settings.dropdownOptions.requireCheckInIdValidationToCompleteCheckIn.no': 'No',
  'core.settings.dropdownOptions.requireCheckInIdValidationToCompleteCheckIn.yes': 'Yes',
  'core.settings.dropdownOptions.checkInIdValidationTemplate.driverLicenseFace':
    'Driver License + Face',
  'core.settings.dropdownOptions.checkInIdValidationTemplate.driverLicenseOnly':
    'Driver License Only',
  'core.settings.dropdownOptions.checkInIdValidationTemplate.driverLicenseFront1Retry':
    'Driver license - Front - 1 retry',
  'core.settings.examples.displayTimeIn.eG700Am700Pm': 'E.g. 7:00 AM / 7:00 PM',
  'core.settings.examples.displayTimeIn.eG07001900': 'E.g. 07:00 / 19:00',
  'core.settings.notes.notesPrefix': 'Note:',
  'core.settings.notes.ifLeftEmptyTheDefaultNameWillBeApplied':
    'If left empty, the default name will be applied',
  'core.settings.notes.ifLeftEmptyTheDefaultHelperTextWillBeApplied':
    'If left empty, the default helper text will be applied',
  'core.settings.notes.enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually':
    'Enabling this option does not impact notifications that are already disabled on the appointment level individually.',
  'core.settings.notes.ifLeftEmptyNoNotificationsWillBeSent':
    'If left empty, no notifications will be sent',
  'core.settings.notes.referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments':
    'Reference number assigned to cancelled or no show appointments may be reused on new appointments',
  'core.settings.messages.leavingThisFieldEmptyWillResultInNoAvailabilityOnTheSchedule':
    'Leaving this field empty will result in no availability on the schedule.',
  'core.settings.modalText.youCanUseTheZoomFeatureAndDragTheImageToAdjustHowThePreviewWillAppearForTheSchedulingUsersTheyWillBeAbleToClickThePreviewToSeeTheFullImage':
    'You can use the zoom feature and drag the image to adjust how the preview will appear for the scheduling users. They will be able  to click the preview to see the full image.',
  'core.settings.defaultValues.referenceNumber': 'Reference Number',
  'core.user.errors.yourRoleDoesNotAllowThisAction': 'Your role does not allow you to {action}',
  'core.user.errors.yourRoleDoesNotAllowYouToPerformThisAction':
    'Your role does not allow you to perform this action',
  'core.user.errors.mustHaveAtLeast8Characters': 'Must have at least 8 characters',
  'core.user.errors.mustContainUpperCaseAndLowerCase': 'Must contain upper-case and lower-case',
  'core.user.errors.mustContainAtLeastOneLetter': 'Must contain at least one letter',
  'core.user.errors.mustContainAtLeastOneSpecialCharacter':
    'Must contain at least one special character',
  'core.user.errors.mustContainAtLeastOneNumber': 'Must contain at least one number',
  'core.user.descriptions.allPermissionsAndFullControlOverAllAccounts':
    'All permissions and full control over all accounts.',
  'core.user.descriptions.godRoleWithLessControl': 'GOD role with less control.',
  'core.user.descriptions.allPermissionsAndFullControlOverTheOrganizationAccount':
    'All permissions and full control over the Organization account.',
  'core.user.descriptions.createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners':
    'Create/edit/delete Appointments, Warehouses, Load Types, Docks, and Users (except Owners).',
  'core.user.descriptions.createEditCancelAppointments': 'Create/edit/cancel Appointments.',
  'core.user.descriptions.editAppointmentStatusTagsAndSubscribers':
    'Edit Appointment Status, tags, and subscribers.',
  'core.user.descriptions.viewOnlyNoCreateOrEditActionsAllowed':
    'View only. No create or edit actions allowed.',
  'core.user.descriptions.carrierAdministrator': 'Carrier administrator.',
  'core.user.descriptions.carrierUser': 'Carrier user',
  'core.user.descriptions.baseUserAccount': 'Base user account.',
  'core.yard.assetContainerEvent.types.arrived': 'Arrived',
  'core.yard.assetContainerEvent.types.arrivedWaiting': 'Arrived/Waiting',
  'core.yard.assetContainerEvent.types.loading': 'Loading',
  'core.yard.assetContainerEvent.types.loadingComplete': 'Loading Complete',
  'core.yard.assetContainerEvent.types.unloading': 'Unloading',
  'core.yard.assetContainerEvent.types.unloadingComplete': 'Unloading Complete',
  'core.yard.assetContainerEvent.types.readyForPickup': 'Ready for Pickup',
  'core.yard.assetContainerEvent.types.departed': 'Departed',
  'core.yard.assetContainerEvent.types.inoperable': 'Inoperable',
  'core.yard.assetContainerEvent.types.missing': 'Missing',
  'core.yard.assetContainerTypes.trailer': 'Trailer',
  'core.yard.assetContainerTypes.container': 'Container',
  'core.yard.assetContainerTypes.oversized': 'Oversized',
  'core.yard.assetContainerTypes.chassis': 'Chassis',
  'core.yard.assetContainerTypes.reefer': 'Reefer',
  'core.yard.assetContainerTypes.other': 'Other',
  'core.yard.assetVisitTypes.live': 'Live',
  'core.yard.assetVisitTypes.drop': 'Drop',
  'core.yard.assetVisitTypes.pickup': 'Hook',
  'core.yard.assetVisitTypes.dropHook': 'Drop & Hook',
  'core.yard.assetVisitDirections.inbound': 'Inbound',
  'core.yard.assetVisitDirections.outbound': 'Outbound',
  'core.yard.assetVisitDirections.inboundAndOutbound': 'In & Out',
  'core.yard.altAssetVisitTypes.live': 'Live',
  'core.yard.altAssetVisitTypes.liveLoad': 'Live Load',
  'core.yard.altAssetVisitTypes.liveUnload': 'Live Unload',
  'core.yard.altAssetVisitTypes.drop': 'Drop',
  'core.yard.altAssetVisitTypes.pickUp': 'Pick Up',
  'core.yard.altAssetVisitTypes.dropHook': 'Drop & Hook',
  'core.yard.altAssetVisitTypes.unknown': 'Unknown',
  'core.yard.assetContainerStates.full': 'Full',
  'core.yard.assetContainerStates.empty': 'Empty',
  'core.yard.assetContainerStates.partiallyLoaded': 'Partially Loaded',
  'core.yard.spotStatuses.open': 'open',
  'core.yard.spotStatuses.closed': 'closed',
  'core.yard.spotStatuses.assigned': 'assigned',
  'core.yard.spotStatuses.unknown': 'unknown',
  'core.yard.spotTypes.parking': 'parking',
  'core.yard.spotTypes.docking': 'docking'
};
